export const upperCaseWords = (str: string) =>
  str?.replace(/^(.)|\s+(.)/g, (c) => c?.toUpperCase());

export const getClinicNameFromClinicCode = (clinicCode: string) =>
  clinicCode?.split('.')[2]?.replace('-', ' ') ?? '';

export const getFullClinicNameFromClinicCode = (clinicCode: string) => {
  const clinic = clinicCode?.split('.');
  const group = clinic[1]?.replace('-', ' ') ?? '';
  const name = clinic[2]?.replace('-', ' ') ?? '';
  return `${group} ${name}`;
};

export const normalizeReferralFileName = (fileName: string): string => {
  return fileName.replaceAll(/\s+/g, '-');
};

export const getCapitalizedWord = <T extends string>(word: string): T => {
  const lowercaseWord = word.replace(/-/g, ' ').toLowerCase().replaceAll('_', ' ');
  return `${lowercaseWord[0].toUpperCase()}${lowercaseWord.slice(1)}` as T;
};

export const camelCaseToSentence = (text: string) => {
  return text.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
};

export const booleanAsText = (value?: boolean) => {
  return `${value}` === 'true' ? 'Yes' : 'No';
};

export const camelCaseToPascalCase = (word: string) => {
  const replacedWord = word.replace(/([A-Z])/g, (match) => ' ' + match);

  return replacedWord[0].toUpperCase() + replacedWord.slice(1);
};

export const asE164Number = (number: string) => {
  let formattedToNumber = number;

  if (!number.startsWith('+')) {
    // For US numbers, assuming 10-digit format
    if (number.length === 10) {
      formattedToNumber = `+1${number}`;
    } else if (number.length === 11 && number.startsWith('1')) {
      formattedToNumber = `+${number}`;
    }
  }

  return formattedToNumber;
};
